import { getWindowWidth } from "lib/checkViewport";
import { useState, useEffect } from "react";

type ViewportSizeType = {
  width: number;
  height: number;
};

export const getViewportSize = (): ViewportSizeType => {
  if (!global.window) return { width: 0, height: 0 };

  const width = getWindowWidth();

  const height =
    window && window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight || document.body.clientWidth;

  return { width, height };
};

export const useWindowSize = (): ViewportSizeType => {
  const [viewport, setViewport] = useState(getViewportSize());

  useEffect(() => {
    let timeout: null | number = null;
    const resizeListener = () => {
      if (typeof timeout === "number") clearTimeout(timeout);
      timeout = global.window.setTimeout(
        () => setViewport(getViewportSize()),
        100
      );
    };

    window.addEventListener("resize", resizeListener);
    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  return viewport;
};
